import { Injectable } from '@angular/core';
import { UserManager, User, UserManagerSettings, SignoutResponse } from 'oidc-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private manager = new UserManager(environment.auth as UserManagerSettings);

  get storedUser(): Promise<User> {
    return this.manager.getUser();
  }

  constructor() { }   
   
  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<User> {
    return this.manager.signinRedirectCallback();
  }
}
